import {
  AvailablePitchTypesAndGroupsDto,
  DateRangeDto,
  PitchType,
  SelectedItemDto,
  UmpireReportForAdminChartConfigDto,
  UmpireReportForAdminChartDataDto,
  UmpireReportForAdminContentConfigDto,
} from 'types/CodegenReportTypes';

import { configurablePitchTypeGroups, configurablePitchTypes } from 'utilities/constants';
import { generateStore } from 'utilities/reportStoreFactory';

type ReportSpecificTypes = {
  // search criteria come from select fields and their type must match selected entries from ...FilterDto type
  // ...FilterDto minus { reportId, configData, reportContentConfig }
  searchCriteria: {
    dateRanges: DateRangeDto[] | undefined;
    seasonNames: string[] | undefined;
    leagues: SelectedItemDto[] | undefined;
  };
  // search chips type must match selected entries from ...ResultDto type
  // ...ResultDto minus { reportId, reportType, reportSubType, reportContentConfig, chartData, configData } AND minus specialConfigOptions
  searchChips: {
    seasonNames: string[] | undefined;
    dateRanges: DateRangeDto[] | undefined;
    leagueNames: string[] | undefined;
  };

  // filters / config area
  specialConfigOptions: { pitchTypeInfo: AvailablePitchTypesAndGroupsDto; availableSessions: SelectedItemDto[] } | undefined; // config related values from ...ResultDto
  selectedConfgValues: UmpireReportForAdminContentConfigDto; // reportContentConfig

  // charts area
  layout: UmpireReportForAdminChartConfigDto | undefined; // configData
  chartData: UmpireReportForAdminChartDataDto[] | undefined; // chartData
};

const defaultValues: ReportSpecificTypes = {
  // search criteria area
  searchCriteria: {
    dateRanges: undefined,
    seasonNames: undefined,
    leagues: undefined,
  },
  searchChips: {
    seasonNames: undefined,
    dateRanges: undefined,
    leagueNames: undefined,
  },

  // filters / config area
  specialConfigOptions: undefined,
  selectedConfgValues: {
    pitchTagging: 'Auto',
    pitchTypes: configurablePitchTypes,
    pitchTypeGroups: configurablePitchTypeGroups,
    pitchGrouping: 'Types',
    pitcherHandedness: 'Both',
    batterHandedness: 'Both',
    strikeZoneDisplay: 'WithBuffers',
    excludedSessions: [],
  },

  // charts area
  layout: undefined,
  chartData: undefined,
};

const useReportStore = generateStore(defaultValues);

export default useReportStore;
